<input autocomplete="off" class="overlay" type="file" [attr.accept]="accept" #inputfile (change)="onSelectImage($event)">
<button mat-button (click)="onButtonClick()">
  <mat-icon class="icon-edit">{{icon}}</mat-icon>
  {{title}}
</button>
